import styled from "styled-components/macro";

export const Container = styled.div`
  background: rgba(239, 236, 232, 0.66);
  padding: 3rem 0;
  @media (min-width: 992px) {
    height: 65vh;
    padding: 0 7.7rem 0 7.8rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
export const ContainerText = styled.div`
  padding: 1rem 1rem 0 1rem;
  h1 {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 38px;
    text-align: center;
    color: #000000;
  }
  p {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    color: #000000;
    padding: 0.5rem 0.5rem 1rem 0.5rem;
  }

  @media (min-width: 992px) {
    padding: 2rem 0 2rem 0;
    h1 {
      font-size: 40px;
      line-height: 47px;
    }
    p {
      font-size: 18px;
      line-height: 24px;
      padding: 0 8rem;
    }
  }
`;
export const ContainerCarousel = styled.div`
  padding: 1rem 0.5rem 1rem 0.7rem;
  @media (min-width: 992px) {
    display: none;
  }
`;
export const ContainerDesktop = styled.div`
  display: none;
  @media (min-width: 992px) {
    padding-bottom: 2rem;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }
`;
export const ContainerCard = styled.div`
  width: 110px;
  height: 66.83px;
  background: #d6d6d6;
  background-blend-mode: multiply;
  margin: 0 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (min-width: 992px) {
    width: 170px;
    height: 90px;
    margin: 0;
  }
`;
export const Img = styled.img`
  width: ${({ adidas, banco, hyundai, mapfre, delta, sy }) =>
    adidas
      ? "60%"
      : banco
      ? "80%"
      : hyundai
      ? "50%"
      : mapfre
      ? "70%"
      : delta
      ? "70%"
      : sy
      ? "70%"
      : "100px"};
`;
